module.exports = __webpack_public_path__ + "img/67afa8826c5d57908529defdb7746f1a.png";